import { BanhoTosa } from "@/utils/svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import facilityIcons from "@/utils/facilityIcons";
import styles from "./styles.module.scss";

export type FacilityItemProps = {
  name: string;
  icon: string;
  subtitle?: string;
  group?: string;
};

const FacilityItem = ({ name, subtitle, icon }: FacilityItemProps) => (
  <div className={styles.wrapper}>
    <div className="avatar-pill--top-start small">
      {icon !== "banho-e-tosa" && icon !== "especial" ? (
        <FontAwesomeIcon
          icon={facilityIcons(icon)}
          style={{
            color: "var(--token-cobasi-colors-lemon-primary)"
          }}
        />
      ) : (
        BanhoTosa
      )}
    </div>
    <div>
      <h4 className="subtitle-md">{name}</h4>
      {subtitle && <p className="body-text-sm">{subtitle}</p>}
    </div>
  </div>
);

export default FacilityItem;
